import React, { useEffect, useState } from "react";
import { Button, Col, Form, message, Modal, Row } from "antd";

import FormInput from "components/FormInput/FormInput";
import FormAutoComplete from "components/FormAutoComplete/FormAutoComplete";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { confirm } = Modal;

const INTERPRETATION_SELECTIONS = [
  { value: "Yes", label: "Yes", key: "Yes" },
  { value: "No", label: "No", key: "No" },
];

const AddEstatePlanningModal = ({
  defaultValues,
  onOk,
  onClose,
  onRemove,
  suggestions,
  visible,
}) => {
  const [form] = useForm();
  const [selections, setSelections] = useState([]);
  const [interpretationSelections, setInterpretationSelections] = useState([]);

  useEffect(() => {
    if (form && defaultValues) {
      form.setFieldsValue(defaultValues);
    }
  }, [form, defaultValues]);

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: Locale.get("estateContingencyPlan.removePlan"),
      okText: Locale.get("estateContingencyPlan.yes"),
      onOk() {
        onRemove();
      },
      onClose() {},
    });
  };

  const handleOnSearchPlans = (inputValue) => {
    const newSelections = inputValue
      ? suggestions.filter((suggestion) => {
          const upperCaseSuggestionValue = suggestion.value.toUpperCase();
          return upperCaseSuggestionValue.includes(inputValue.toUpperCase());
        })
      : [];

    setSelections(newSelections);
  };

  const handleOnSearchInterpretations = (inputValue) => {
    const newSelections = inputValue
      ? INTERPRETATION_SELECTIONS.filter((suggestion) => {
          const upperCaseSuggestionValue = suggestion.value.toUpperCase();
          return upperCaseSuggestionValue.includes(inputValue.toUpperCase());
        })
      : [];

    setInterpretationSelections(newSelections);
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          {Locale.get("estateContingencyPlan.remove")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("estateContingencyPlan.savePlan")}
        </Button>,
      ]
    : [
        <Button key="cancel" onClick={onClose}>
          {Locale.get("estateContingencyPlan.cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("estateContingencyPlan.addNewPlan")}
        </Button>,
      ];

  return (
    <Modal
      title={Locale.get("estateContingencyPlan.estatePlanning")}
      visible={visible}
      onOk={handleOnOkButtonClick}
      onCancel={onClose}
      footer={footer}
      width="60%"
      destroyOnClose
    >
      <Form form={form} preserve={false}>
        <Row gutter={16}>
          <Col span={12}>
            <FormAutoComplete
              name="plan"
              label={Locale.get("estateContingencyPlan.plan")}
              requiredErrorMessage={Locale.get(
                "estateContingencyPlan.errMsgPlan"
              )}
              placeholder={Locale.get("estateContingencyPlan.planPlaceholder")}
              selections={selections}
              onSearch={handleOnSearchPlans}
            />
          </Col>
          <Col span={12}>
            <FormAutoComplete
              name="interpretation"
              label={Locale.get("estateContingencyPlan.interpretation")}
              requiredErrorMessage={Locale.get(
                "estateContingencyPlan.errMsgInterpretation"
              )}
              selections={interpretationSelections}
              onSearch={handleOnSearchInterpretations}
            />
          </Col>
          <Col span={24}>
            <FormInput
              label={Locale.get("estateContingencyPlan.notes")}
              name="remarks"
              placeholder={Locale.get("estateContingencyPlan.notesPlaceholder")}
              type="textArea"
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddEstatePlanningModal;
